<template>
  <v-card>
    <v-card-title>
      <v-layout row>
        <span class="headline mb-0">B/L</span>
        <span class="ml-2">
          <v-checkbox
            :label="this.poNo + ' Only'"
            style="margin-top: 0px; height: 20px"
            v-model="only"
          />
        </span>
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="packages"
      :loading="loading"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <td width="150">{{ props.item.blNo }}</td>
        <td width="150">{{ props.item.invoiceNo }}</td>
        <td :style="diffStyle('poNo', props.item)" width="150">{{ props.item.poNo }}</td>
        <td width="200">{{ props.item.productCode }}:{{ props.item.productName }}</td>
        <td width="200">{{ props.item.skuCode }}</td>
        <td width="100">{{ props.item.paid === 1 ? '有償' : '無償' }}</td>
        <td width="100">{{ props.item.cartonStartNo }}-{{ props.item.cartonEndNo }}</td>
        <td width="100">{{ props.item.perCartonQty }}</td>
        <td :style="diffStyle('qty', props.item)" width="100">{{ props.item.totalQty }}</td>
        <td width="100">{{ props.item.currencyCode }}</td>
        <td :style="diffStyle('unitPrice', props.item)" width="100">{{ props.item.unitPrice }}</td>
        <td width="100">{{ props.item.saStatus }}</td>
        <td width="100">{{ props.item.handleStatus }}</td>
        <td width="100">
          <v-btn
            @click="cancelSa(props.item)"
            v-if="props.item.idx === 0 && props.item.handleStatus!='CANCELED'"
            v-permit.SHARP_PCD_SA_CANCEL
          >S/A取消</v-btn>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: ['id'],
  data() {
    return {
      form: {},
      status: { NORMAL: '', CONFLICT: 'PO变更', CANCEL: 'PO取消' },
      headers: [
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: 'INV NO', value: 'invoiceNo', sortable: false },
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '品種', value: 'productCode', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '有償/無償', value: 'paid', sortable: false },
        { text: 'Carton', value: 'cartonStartNo', sortable: false },
        { text: '入り数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '単価', value: 'unitPrice', sortable: false },
        { text: '状态', value: 'status', sortable: false },
        { text: '处理状态', value: 'handleStatus', sortable: false },
        { text: '', value: 'op', sortable: false }
      ],
      results: [],
      loading: false,
      conflictType: 'UNKNOWN',
      conflictFields: [],
      newUnitPrice: null,
      only: true
    }
  },
  methods: {
    diffStyle(prop, item) {
      if (this.poNo === item.poNo && this.conflictFields.indexOf(prop) !== -1)
        return 'color: red; font-weight: bold; font-size: 16px'
      return ''
    },
    conflict(type, fields, newUnitPrice) {
      this.conflictType = type || 'UNKNOWN'
      this.conflictFields = fields || []
      this.newUnitPrice = newUnitPrice
    },
    cancelSa(item) {
      this.$confirm({ content: '該当BLを取り消してよろしいでしょか？?' }).then(
        () => {
          this.cancel(item)
        }
      )
    },
    cancel(item) {
      this.$http
        .put(`/delivery-orders/${item.shipmentId}/cancel-sa`)
        .then(() => {
          this.$message('', 'SA取消')
          this.load()
        })
        .catch(res => {
          if (res.response.data.message == 'INVALID_STATUS') {
            this.$message(
              this.$t('app.messages.errors.title'),
              'DO未解除或DO解除未确认'
            )
          }
        })
    },
    load() {
      this.loading = true
      this.$http.get(`/shipping-advices/conflict?id=${this.id}`).then(res => {
        this.results = [...res.data]
        this.loading = false
      })
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    poNo() {
      return this.$route.query.poNo
    },
    packages() {
      var arr = []
      this.results.forEach(
        SA =>
          (arr = arr.concat(
            SA.packages.map(pkg => ({
              ...pkg,
              saStatus: SA.status,
              blNo: SA.blNo || '',
              invoiceNo: pkg.invoiceNo || '',
              poNo: pkg.poNo || '',
              shipmentId: SA.id,
              handleStatus: SA.handleStatus
            }))
          ))
      )
      arr.sort((a, b) =>
        (b.blNo + b.invoiceNo + b.poNo).localeCompare(
          a.blNo + a.invoiceNo + a.poNo
        )
      )
      if (this.only) {
        arr = arr.filter(pkg => this.poNo === pkg.poNo)
      }

      var obj = []
      return arr.map(pkg => {
        if (!obj[pkg.blNo]) obj[pkg.blNo] = 0
        return {
          ...pkg,
          idx: obj[pkg.blNo]++
        }
      })
    }
  }
}
</script>

